import { type CSSProperties } from "react";
import { FilterChips, type FilterState } from "./FilterChips";
import type { LibraryNode } from "../../../lib/types";

interface ActivityHeaderProps {
  eventCount: number;
  filters: FilterState;
  onFiltersChange: (filters: FilterState) => void;
  agents: LibraryNode[];
}

export function ActivityHeader({ eventCount, filters, onFiltersChange, agents }: ActivityHeaderProps) {
  const root: CSSProperties = {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    marginBottom: 24,
    fontFamily: "var(--font-sans)",
  };

  return (
    <div style={root}>
      <div>
        <div style={{ fontSize: 16, fontWeight: 500, color: "var(--color-text-primary)" }}>
          Activity
        </div>
        <div style={{ fontSize: 12, color: "var(--color-text-tertiary)", marginTop: 2 }}>
          Interaction history · {eventCount} {eventCount === 1 ? "event" : "events"} today
        </div>
      </div>
      <FilterChips filters={filters} onChange={onFiltersChange} agents={agents} />
    </div>
  );
}
